import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, exhaustMap } from 'rxjs/operators';
import { OrderService } from '@services/order.service';
import * as AdminOrdersActions from './admin-orders.actions';

@Injectable()
export class AdminOrdersEffects {
  private readonly actions$ = inject(Actions);
  private readonly orderService = inject(OrderService);

  loadAdminOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AdminOrdersActions.loadAdminOrders),
      exhaustMap(action =>
        this.orderService.getOrders(action.page, action.size, action.status, action.customerQuery).pipe(
          map(orderPage => AdminOrdersActions.loadAdminOrdersSuccess({ orderPage })),
          catchError(error => of(AdminOrdersActions.loadAdminOrdersFailure({ error })))
        )
      )
    )
  );
}
